import { cn } from "@/lib/utils";
import nestPointsIcon from "@/assets/nest-points-icon.png";

interface NestPointsDisplayProps {
  points: number;
  className?: string;
  showIcon?: boolean;
  size?: "sm" | "md" | "lg";
}

export const NestPointsDisplay = ({ 
  points, 
  className,
  showIcon = true,
  size = "md" 
}: NestPointsDisplayProps) => {
  const sizeClasses = {
    sm: "text-sm",
    md: "text-base",
    lg: "text-lg font-semibold"
  };

  const iconSizes = {
    sm: "h-4 w-4",
    md: "h-5 w-5",
    lg: "h-6 w-6"
  };

  return (
    <span className={cn("inline-flex items-center gap-1.5 text-primary", sizeClasses[size], className)}>
      {showIcon && (
        <img 
          src={nestPointsIcon} 
          alt="Nest Points" 
          className={cn("object-contain", iconSizes[size])}
        />
      )}
      <span className="font-medium">{points.toLocaleString()}</span>
      <span className="text-muted-foreground">Nest Points</span>
    </span>
  );
};
